// extracted by mini-css-extract-plugin
export default {"root":"RootLayout_root__2sWeb","main":"RootLayout_main__AmF5s"};